// extracted by mini-css-extract-plugin
module.exports = {"header":"header__35IEx","title":"title__22jyu"};